import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';
import Buttons from '../../../Litho/Components/Button/Buttons';
import ProcessStep from '../../../Litho/Components/ProcessStep/ProcessStep';

const steps = [
	{
		title: 'Booking',
		content: 'Confirm FCL/LCL space and sailing schedule.',
		icon: 'line-icon-Edit',
	},
	{
		title: 'Origin handling',
		content: 'Pickup, stuffing, and export customs.',
		icon: 'line-icon-Box-Open',
	},
	{
		title: 'Ocean transit',
		content: 'Track milestones across ports and hubs.',
		icon: 'line-icon-Ship-2',
	},
	{
		title: 'Delivery',
		content: 'Import clearance and final-mile delivery.',
		icon: 'line-icon-Location-2',
	},
];

const ProcessSteps = () => {
  return (
    <section className='py-[130px] bg-lightgray lg:py-[90px] md:py-[75px] sm:py-[50px] overflow-hidden'>
      <Container>
        <Row className='justify-center'>
          <Col xl={5} sm={8} className='text-center mb-24 font-serif sm:mb-12'>
            <span className='text-xmd mb-[20px] block text-fastblue font-medium'>
              Simple ocean process
            </span>
            <h5 className='text-darkgray font-medium inline-block'>
              High-quality and cost-effective sea freight
            </h5>
          </Col>
          <ProcessStep
            grid='row-cols-1 row-cols-lg-4 row-cols-sm-2 gap-y-10'
            theme='process-step-style-01'
            className=''
            data={steps}
            animation={fadeIn}
          />
        </Row>
      </Container>
    </section>
  );
};

export default ProcessSteps;
